import { useQuery } from '@tanstack/react-query'
import { useAuthContext } from '../../hooks/useAuthContext'
import * as bloodKitsApi from '../../api/health/bloodKits'

const useSetup = () => {
	const { user } = useAuthContext()

	const { isLoading: isLoadingFocus, isError: isErrorFocus, error: errorFocus, data: focus } = useQuery({
		queryKey: ['focus'],
		queryFn: async () => {
			const response = await fetch(`/api/health/api/focus/${user._id}`, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user.token}`
				}
			})

			if (response.status === 204) return null

			const json = await response.json()

			if (!response.ok) throw new Error(json.error)

			return json ?? null
		}
	})

	const { isLoading: isLoadingKits, isError: isErrorKits, error: errorKits, data: kits } = useQuery({
		queryKey: ['kits'],
		queryFn: async () => {
			const response = await bloodKitsApi.getKits(user._id, user.token)

			const json = await response.json()

			if (!response.ok) throw new Error(json.error)

			return json ?? null
		}
	})

	const { isLoading: isLoadingLifestyle, isError: isErrorLifestyle, error: errorLifestyle, data: lifestyle } = useQuery({
		queryKey: ['lifestyle'],
		queryFn: async () => {
			const response = await fetch(`/api/health/api/assessments/${user._id}/lifestyle`, {
				headers: {
					Authorization: `Bearer ${user.token}`
				}
			})
	
			if (response.status === 204) return null
	
			const json = await response.json()
	
			if (!response.ok) throw new Error(json.error)

			return json ?? null
		}
	})

	return {
		isLoadingFocus,
		errorFocus,
		isLoadingKits,
		isLoadingLifestyle,
		isErrorFocus,
		isErrorKits,
		isErrorLifestyle,
		errorLifestyle,
		lifestyle,
		errorKits,
		focus,
		kits
	}
}

export default useSetup
